import { render } from "./CustomerStats.vue?vue&type=template&id=69c88ec2"
import script from "./CustomerStats.vue?vue&type=script&lang=js"
export * from "./CustomerStats.vue?vue&type=script&lang=js"

import "./CustomerStats.vue?vue&type=style&index=0&id=69c88ec2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__